import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ServerSettings from './ServerSettings';


const SettingsPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1); // Go back to previous page
    };



    return (
        <div className="min-h-screen bg-background flex flex-col justify-center py-12 sm:px-6 lg:px-8 relative overflow-hidden">
            {/* Background decoration */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none">
                <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary-200/20 blur-3xl"></div>
                <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-primary-300/20 blur-3xl"></div>
            </div>

            <div className="sm:mx-auto sm:w-full sm:max-w-md relative z-10">
                {/* Header Actions */}
                <div className="absolute top-0 left-0 -mt-16 ml-4 sm:ml-0">
                    <button
                        onClick={handleGoBack}
                        className="p-2 rounded-full text-gray-500 hover:bg-white/50 hover:text-primary-600 transition-colors"
                        title={t('common.back')}
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                </div>

                {/* Content */}
                <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md relative z-10">
                    <div className="bg-white py-8 px-4 shadow-hard sm:rounded-2xl sm:px-10 border border-white/50 backdrop-blur-sm">
                        <div className="mb-6">
                            <h1 className="font-serif text-3xl" style={{ color: 'var(--text-strong)' }}>{t('common.settings')}</h1>
                        </div>

                        <ServerSettings />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsPage; 